/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDaemonSet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 4V2h-2v2zM10 2v2H8V2zm0 6V6H8v2zm8 14V10H2v12zM4 16v-4h12v4zm0 4v-2h12v2zM14 4V2h-2v2zm4-2v2h-2V2zm4 4v2h-2V6zm0 6v-2h-2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDaemonSet as DaemonSet };
